import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function ShoppingCartIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12918_64110" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12918_64110)"><path d="M7.17014 21.975C6.67364 21.975 6.25039 21.7983 5.90039 21.4447C5.55039 21.0912 5.37539 20.6663 5.37539 20.1698C5.37539 19.6733 5.55214 19.25 5.90564 18.9C6.25914 18.55 6.68414 18.375 7.18064 18.375C7.67714 18.375 8.10039 18.5518 8.45039 18.9053C8.80039 19.2588 8.97539 19.6838 8.97539 20.1803C8.97539 20.6768 8.79864 21.1 8.44514 21.45C8.09164 21.8 7.66664 21.975 7.17014 21.975ZM17.1701 21.975C16.6736 21.975 16.2504 21.7983 15.9004 21.4447C15.5504 21.0912 15.3754 20.6663 15.3754 20.1698C15.3754 19.6733 15.5521 19.25 15.9056 18.9C16.2591 18.55 16.6841 18.375 17.1806 18.375C17.6771 18.375 18.1004 18.5518 18.4504 18.9053C18.8004 19.2588 18.9754 19.6838 18.9754 20.1803C18.9754 20.6768 18.7986 21.1 18.4451 21.45C18.0916 21.8 17.6666 21.975 17.1701 21.975ZM5.87539 5.475L8.62539 11.175H15.8254L18.9504 5.475H5.87539ZM5.12539 3.975H19.8521C20.235 3.975 20.5262 4.15 20.7259 4.5C20.9256 4.85 20.9254 5.2 20.7254 5.55L17.3504 11.625C17.1671 11.9417 16.9291 12.1958 16.6364 12.3875C16.3437 12.5792 16.0234 12.675 15.6754 12.675H8.10039L6.70039 15.275H18.9754V16.775H6.92539C6.22539 16.775 5.72122 16.5417 5.41289 16.075C5.10456 15.6083 5.10872 15.0833 5.42539 14.5L7.02539 11.55L3.22539 3.5H1.27539V2H4.20039L5.12539 3.975Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}